import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DostavnicaHladService {

  constructor(private _http: HttpClient) { }

  prometHlad(a: any) {
    return this._http.post(AppConfig.ipAddress + 'promet_hlad', a)
      .pipe(map((res: any) => res));
  }

  urediPoziciju(a: any) {
    return this._http.post(AppConfig.ipAddress + 'pozicija_uredi', a)
      .pipe(map((res: any) => res));
  }
}
